import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-348909fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "deviceManage"
};
import { reactive, toRefs, unref, ref, onMounted, nextTick, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { weChatrequest } from '@/utils/request';
import deviceList from './list';
const __default__ = {
  name: "DeviceManage"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const store = useStore();
    const state = reactive({
      split: 0.13,
      cityId: "",
      loading: false,
      defaultProps: {
        label: "name",
        children: "children"
      },
      treeData: [],
      defaultCheckNode: [],
      defaultExendNode: [],
      currentNodeKey: ''
    });
    // isFirst代表是否第一次模拟点击事件
    const handleNodeClick = (params, isFirst) => {
      nextTick(() => {
        state.defaultCheckNode = [params];
      });
      state.cityId = params.id;
      state.currentNodeKey = params.id;
    };
    const route = useRoute();
    const tree = ref(null);
    // 重置页面状态的函数
    const resetPageState = () => {
      nextTick(() => {
        state.cityId = "";
        state.defaultCheckNode = [];
        state.defaultExendNode = "";
        state.currentNodeKey = "";
        // 重置树形数据
        if (state.treeData[0]?.children) {
          state.defaultExendNode = state.treeData[0].children[0].id;
        }
      });
    };

    // 加载树形数据的函数
    const loadTreeData = async () => {
      state.loading = true;
      try {
        const res = await weChatrequest({
          url: '/api/v1/sysArea/findTree',
          method: "get"
        });
        state.treeData = [res.data];
        if (state.treeData[0]?.children) {
          state.defaultExendNode = state.treeData[0].children[0].id;
        }
      } catch (error) {
        console.error('加载树形数据失败:', error);
      } finally {
        state.loading = false;
      }
    };
    onMounted(async () => {
      await loadTreeData();
      if (route.query.areaId) {
        //得看看选中问题
        state.defaultExendNode = route.query.areaId;
        state.cityId = route.query.areaId;
        nextTick(() => {
          state.currentNodeKey = route.query.areaId;
        });
      }
    });

    // 监听路由变化
    watch(() => route.query, (newQuery, oldQuery) => {
      console.log('路由参数变化:', {
        newQuery,
        oldQuery
      });

      // 如果fromRunData不存在，重置页面状态
      if (!newQuery.fromRunData) {
        console.log('fromRunData不存在，重置页面状态');
        resetPageState();
        // 重新加载树形数据
        loadTreeData();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(deviceList))]);
    };
  }
});